import { ONE_HOUR, ONE_MINUTE } from '../../tools/utils'

export const SESSION_TIME_OUT_DELAY = 4 * ONE_HOUR
export const SESSION_EXPIRATION_DELAY = 15 * ONE_MINUTE
